import { render, staticRenderFns } from "./TNoContent.vue?vue&type=template&id=4a93847d&scoped=true"
import script from "./TNoContent.vue?vue&type=script&lang=js"
export * from "./TNoContent.vue?vue&type=script&lang=js"
import style0 from "./TNoContent.vue?vue&type=style&index=0&id=4a93847d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a93847d",
  null
  
)

export default component.exports